import { twMerge } from "tailwind-merge";

import { PROGRAM_BTN_CLASS } from "@/components/user/common/ComingSoonBtn";

interface ProgramLinkBtnProps {
    /** 버튼 문구 */
    label: string;
    /** 이동할 URL (새 창으로 열림) */
    href: string;
    /** 버튼 클래스 보정 (여백 등) */
    className?: string;
}

/**
 * 신청/사이트 URL이 확정된 프로그램용 버튼.
 * ComingSoonBtn과 동일한 옥타곤 규격이며, 클릭 시 새 창으로 이동한다.
 */
export default function ProgramLinkBtn({ label, href, className }: ProgramLinkBtnProps) {
    return (
        <a href={href} target="_blank" rel="noreferrer" className={twMerge(PROGRAM_BTN_CLASS, className)}>
            <span>{label}</span>
            <span className="absolute left-0 top-0 border-[8px] border-black border-b-transparent border-r-transparent" />
            <span className="absolute bottom-0 left-0 border-[8px] border-black border-r-transparent border-t-transparent" />
            <span className="absolute right-0 top-0 border-[8px] border-black border-b-transparent border-l-transparent" />
            <span className="absolute bottom-0 right-0 border-[8px] border-black border-l-transparent border-t-transparent" />
        </a>
    );
}
